<template>
  <div class='main-bc-wrapper'>
    <div class="bcpo-wrapper ">
      <div class="poquagga-wrapper">
        <v-quagga
          :onDetected="logIt"
          :readerSize="readerSize"
          :readerTypes="['code_128_reader', 'ean_reader']"
          :aspectRatio="aspectRatio"
        ></v-quagga>
      </div>
      <div class="pobarcodeText">
        <template v-if="showText" >
          <h3>Your barcode is {{dectectedCode}}</h3>
          <h4>We will redirect you to a project if there is one associated with this code.</h4>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueQuagga from 'vue-quaggajs';

Vue.use(VueQuagga);

  export default {
    name: 'VueBarcodePopover',
    props: ['locationIndex'],
    data () {
      return {
        readerSize: {
          width: 640,
          height: 480
        },
        aspectRatio: { min: 1, max: 2 },
        showText: false,
        dectectedCode: ''
      }
    },
    methods: {
      logIt(data) {
        var emitData = {
          code: data.codeResult.code,
          index: this.locationIndex
        }
        this.$emit("getBarcode", emitData);
      }

    }
  }
</script>

<style lang="scss">
  .main-bc-wrapper {
    width: 600px;
    height: 400px;
    overflow-y: hidden;
    padding-left: 20px;
  }
  .bcpo-wrapper {
    width: 90%;
    .poquagga-wrapper {
      .scanner {
        canvas {
          margin: 0 40px;
        }
      }
    }

  }
  // @media (width)
</style>
